import { render } from "./acceptance-object.vue?vue&type=template&id=4de303cc"
import script from "./acceptance-object.vue?vue&type=script&lang=js"
export * from "./acceptance-object.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__